import { itemColor } from "utils/Common/ProgressBarColor";

interface Props {
  value: number;
  width?: number | string;
  isFlagged?: boolean;
}

export default function ProgressBar({
  value,
  width = "100%",
  isFlagged = false,
}: Props) {
  const pct = Math.min(100, Math.max(0, value));
  const color = itemColor(pct, isFlagged);

  return (
    <div
      style={{
        width,
        height: 5,
        background: "var(--bg)",
        borderRadius: 4,
        overflow: "hidden",
        border: "0.5px solid var(--bd)",
        flexShrink: 0,
        margin: "8px 0",
      }}
    >
      <div
        style={{
          width: `${pct}%`,
          height: "100%",
          borderRadius: 3,
          background: color,
          transition: "width 0.3s ease",
        }}
      />
    </div>
  );
}
